'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PercentInputController = function () {
    function PercentInputController($element) {
        'ngInject';

        (0, _classCallCheck3.default)(this, PercentInputController);
        this.localInput = void 0;
        this.localInput_old = void 0;
        this._$element = $element;
    }

    (0, _createClass3.default)(PercentInputController, [{
        key: '$onInit',
        value: function $onInit() {
            // console.log(this.index, this.data);
            this.localInput = this.data;
            this.localInput_old = this.data;
        }
    }, {
        key: '$onChanges',
        value: function $onChanges(_ref) {
            var data = _ref.data;
            var currentValue = data.currentValue,
                previousValue = data.previousValue;

            this.localInput = currentValue;
            this.localInput_old = currentValue;
            // console.log(currentValue, previousValue);
        }
    }, {
        key: 'handleArrowClick',
        value: function handleArrowClick(dir) {
            if (!dir && this.localInput - 1 < 0 || dir && this.localInput + 1 > 10000) {
                return;
            }
            this.onUpdate({
                index: this.index,
                value: dir ? this.localInput + 1 : this.localInput - 1
            });
        }
    }, {
        key: 'handleArrowClickInt',
        value: function handleArrowClickInt(dir) {
            if (!dir && this.localInput - 100 < 0 || dir && this.localInput + 100 > 10000) {
                return;
            }
            this.onUpdate({
                index: this.index,
                value: dir ? this.localInput + 100 : this.localInput - 100
            });
        }
    }, {
        key: 'hanldeLocalChange',
        value: function hanldeLocalChange() {
            var rawValue = ('' + this._$element[0].querySelector('input').value).replace(',', '.');
            if (rawValue.includes('.')) {
                var _$split = ('' + rawValue).split('.'),
                    _$split2 = (0, _slicedToArray3.default)(_$split, 2),
                    int = _$split2[0],
                    dec = _$split2[1];

                if (dec.length > 2) {
                    this.localInput = this.localInput_old;
                    return;
                }
            }
            if (isNaN(this.localInput) || this.localInput > 10000) {
                this.localInput = this.localInput_old;
            } else {
                this.localInput_old = this.localInput;
                this.onUpdate({
                    index: this.index,
                    value: this.localInput
                });
            }
        }
    }]);
    return PercentInputController;
}();

exports.default = PercentInputController;


// WEBPACK FOOTER //
// ./client/app/components/percent/percentInput/percentInput.controller.js